var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevvAccessory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1429 10C20.1429 7.24301 17.8358 5 15 5C12.1642 5 9.85714 7.24301 9.85714 10H6V21.875C6 23.6009 7.43908 25 9.21429 25H20.7857C22.5609 25 24 23.6009 24 21.875V10H20.1429ZM15 6.25C17.1269 6.25 18.8571 7.93223 18.8571 10H11.1429C11.1429 7.93223 12.8731 6.25 15 6.25ZM22.7143 21.875C22.7143 22.9089 21.8491 23.75 20.7857 23.75H9.21429C8.15088 23.75 7.28571 22.9089 7.28571 21.875V11.25H9.85714V13.125C9.85714 13.4702 10.145 13.75 10.5 13.75C10.855 13.75 11.1429 13.4702 11.1429 13.125V11.25H18.8571V13.125C18.8571 13.4702 19.1449 13.75 19.5 13.75C19.8551 13.75 20.1429 13.4702 20.1429 13.125V11.25H22.7143V21.875Z",
    fill: "#61A578"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevvAccessory);
export default __webpack_public_path__ + "static/media/revv_accessory.045c7a4e117c53589f6de25cb47acc56.svg";
export { ForwardRef as ReactComponent };